import { Component, OnInit } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { Disclaimer } from '../../model/index';

@Component({
    selector: 'balances-disclaimer',
    templateUrl: './balances-disclaimer.component.html'
})
export class BalancesDisclaimerComponent implements OnInit {

    disclaimersList: Disclaimer[] = [];
    disclaimersListSpecial: Disclaimer[] = [];
    disclaimersListDefault: Disclaimer[] = [];

    disclaimersListSub: any;

    constructor(
        private translationService: PershingTranslationService,
        private balancesService: BalancesService
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
     }

    ngOnInit() {
        this.disclaimersListSub = this.balancesService.disclaimersList$.subscribe(data => {
            if (data && data.length > 0) {
                this.disclaimersList = data.filter(item => { return item.show && item.legendByIndex; }).sort(
                    (a, b) => a.legendSymbol.localeCompare(b.legendSymbol));
                this.disclaimersListSpecial = data.filter(item => { return item.show && !item.legendByIndex && item.legendSymbol !== 'noLegend'; });
                this.disclaimersListDefault = data.filter(item => { return item.show && item.legendSymbol === 'noLegend'; });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.disclaimersListSub) {
            this.disclaimersListSub.unsubscribe();
        }
    }
}
